import Translations from './translations';

const Constants = {
  context: {
    name: 'storever',
   // logo: '@/assets/images/storever/logo-small-white.png',
    logo: 'https://dsmanager.storever.com/content/images/logo-auth.png',
    color: 'orange'
  },
  colors: {
    storever: {
      primary: '#ff6a00',
      light: '#fce8da',
      dark: '#a04402'
    }
  },
  trackTypes: {
    UNDEFINED: {
      value: 0,
      text: Translations.trackTypes.PLAYLIST,
      key: 'UNDEFINED',
      icon: 'fa-list-music'
    },
    //PLAYLIST: { value: 0, text: Translations.trackTypes.UNDEFINED, key: "PLAYLIST" },
    MUSIC: {
      value: 1,
      text: Translations.trackTypes.MUSIC,
      key: 'MUSIC',
      icon: 'fa-music'
    },
    JINGLE: {
      value: 2,
      text: Translations.trackTypes.JINGLE,
      key: 'JINGLE',
      icon: 'fa-drum'
    },
    PROMO: {
      value: 3,
      text: Translations.trackTypes.PROMO,
      key: 'PROMO',
      icon: 'fa-ad'
    },
    VOICE_TRACK: {
      value: 4,
      text: Translations.trackTypes.VOICE_TRACK,
      key: 'VOICE_TRACK',
      icon: 'fa-microphone-alt'
    },
    PODCAST: {
      value: 5,
      text: Translations.trackTypes.PODCAST,
      key: 'PODCAST',
      icon: 'fa-podcast'
    },
    FILLER: {
      value: 9,
      text: Translations.trackTypes.FILLER,
      key: 'FILLER',
      icon: 'fa-ad'
    }
  },
  trackStates: {
    VALID: { value: 1, text: 'Valid', key: 'VALID' },
    INVALID: { value: 2, text: 'Invalid', key: 'INVALID' }
  },
  trackListProperties: [
    {
      name: 'typeID',
      label: 'Type',
      fileTypes: 'all'
    },
    {
      name: 'title',
      label: 'Title',
      fileTypes: 'all'
    },
    {
      name: 'artist',
      label: 'Artist',
      fileTypes: ['JINGLE', 'PODCAST']
    },
    {
      name: 'artists',
      label: 'Artists',
      fileTypes: ['MUSIC']
    },
    {
      name: 'styles',
      label: 'Styles',
      fileTypes: ['MUSIC', 'JINGLE']
    },
    {
      name: 'languages',
      label: 'Languages',
      fileTypes: 'all'
    },
    {
      name: 'label',
      label: 'Label',
      fileTypes: ['MUSIC']
    },
    {
      name: 'description',
      label: 'Description',
      fileTypes: 'all'
    },
    {
      name: 'tags',
      label: 'Tags',
      fileTypes: 'all'
    },
    {
      name: 'bpm',
      label: 'BPM',
      fileTypes: 'all'
    },
    {
      name: 'year',
      label: 'Year',
      fileTypes: 'all'
    },
    {
      name: 'mood',
      label: 'Mood',
      fileTypes: ['MUSIC', 'JINGLE']
    },
    {
      name: 'energy',
      label: 'Energy',
      fileTypes: ['MUSIC', 'JINGLE']
    },
    {
      name: 'gender',
      label: 'Gender',
      fileTypes: ['MUSIC', 'JINGLE']
    },
    {
      name: 'isExplicit',
      label: 'Explicit',
      fileTypes: 'all'
    },
    {
      name: 'duration',
      label: 'Duration',
      fileTypes: 'all'
    },
    {
      name: 'publicationDate',
      label: 'Added',
      fileTypes: 'all'
    }
  ],
  moods: {
    /* 0: */
    //{ value: 0, picture="" ,text: Translations.moods.UNDEFINED, key: "UNDEFINED" },
    1: {
      value: 1,
      icon: 'far fa-frown',
      text: Translations.moods.NEGATIVE,
      key: 'NEGATIVE'
    },
    2: {
      value: 2,
      icon: 'far fa-meh',
      text: Translations.moods.NEUTRAL,
      key: 'NEUTRAL'
    },
    3: {
      value: 3,
      icon: 'far fa-smile',
      text: Translations.moods.POSITIVE,
      key: 'POSITIVE'
    }
  },
  energies: {
    /* 0: */
    //{ value: 0, picture="" ,text: Translations.moods.UNDEFINED, key: "UNDEFINED" },
    1: {
      value: 1,
      icon: 'fas fa-battery-empty',
      text: Translations.energies.EMPTY,
      key: 'EMPTY'
    },
    2: {
      value: 2,
      icon: 'fas fa-battery-quarter',
      text: Translations.energies.QUARTER,
      key: 'QUARTER'
    },
    3: {
      value: 3,
      icon: 'fas fa-battery-half',
      text: Translations.energies.HALF,
      key: 'HALF'
    },
    4: {
      value: 4,
      icon: 'fas fa-battery-three-quarters',
      text: Translations.energies.THREE_QUARTER,
      key: 'THREE_QUARTER'
    },
    5: {
      value: 5,
      icon: 'fas fa-battery-full',
      text: Translations.energies.FULL,
      key: 'FULL'
    }
  },
  genders: {
    //0: { value: 0, icon: "fas fa-minus", text: Translations.genders.UNDEFINED, key: "UNDEFINED" },
    1: {
      value: 1,
      icon: 'fas fa-venus',
      text: Translations.genders.FEMALE,
      key: 'FEMALE'
    },
    2: {
      value: 2,
      icon: 'fas fa-mars',
      text: Translations.genders.MALE,
      key: 'MALE'
    },
    3: {
      value: 3,
      icon: 'fas fa-venus-mars',
      text: Translations.genders.MIXED,
      key: 'MIXED'
    },
    4: {
      value: 4,
      icon: 'fas fa-microphone-slash',
      text: Translations.genders.INSTRUMENTAL,
      key: 'INSTRUMENTAL'
    }
  },
  boxTypes: {
    BOX: { value: 1, text: Translations.boxTypes.BOX, key: 'BOX' },
    PLAYLIST: {
      value: 2,
      text: Translations.boxTypes.PLAYLIST,
      key: 'PLAYLIST'
    },
    SMARTBOX: {
      value: 3,
      text: Translations.boxTypes.SMARTBOX,
      key: 'SMARTBOX'
    }
  },
  boxTypesWithoutSmartBox: {
    BOX: { value: 1, text: Translations.boxTypes.BOX, key: 'BOX' },
    PLAYLIST: {
      value: 2,
      text: Translations.boxTypes.PLAYLIST,
      key: 'PLAYLIST'
    },
  },
  daysOfWeek: [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
  ],
  fields: [
    { name: 'title', label: 'Title', type: 'alpha', default: '', placeholder: 'Title'},
    { name: 'description', label: 'Info', type: 'alpha', default: '', placeholder: 'Info'},
    { name: 'artists', label: 'Artist(s)', type: 'list', default: [] },
    { name: 'categories', label: 'Categories', type: 'list', default: [] , placeholder: 'Categories'},
    { name: 'targets', label: 'Target(s)', type: 'list', default: [] , placeholder: 'Target(s)'},
    { name: 'artistName', label: 'Artist(s) name', type: 'alpha', default: '', placeholder: 'Artist(s) name' },
    { name: 'styles', label: 'Style(s)', type: 'list', default: [] },
    { name: 'languages', label: 'Language(s)', type: 'list', default: [] },
    { name: 'labels', label: 'Label(s)', type: 'list', default: [] },
    { name: 'tags', label: 'Tag(s)', type: 'list', default: [] },
    { name: 'instruments', label: 'Instrument(s)', type: 'list', default: [] },
    { name: 'vocalInstruments', label: 'Vocal instrument(s)', type: 'list', default: [] },
    { name: 'year', label: 'Year', type: 'numeric', default: '' },
    { name: 'bpm', label: 'Bpm', type: 'numeric', default: '' },
    { name: 'mood', label: 'Mood', type: 'equals', default: [] },
    { name: 'energy', label: 'Energy', type: 'equals', default: [] },
    { name: 'gender', label: 'Gender', type: 'equals', default: [] },
    { name: 'isExplicit', label: 'Explicit', type: 'equals', default: false },
    { name: 'duration', label: 'Duration', type: 'numeric', default: null },
    { name: 'publicationDate', label: 'Creation date', type: 'numeric', default: new Date() },
    { name: 'type', label: 'Track type', type: 'contains', default: [] },
    { name: 'boxes', label: 'Box(es)', type: 'list', default: [] },
    { name: 'sources', ref:"stations", label: 'Stations(s)', type: 'include', default: [] },
    { name: 'exc-sources', ref:"stations", label: 'Excluded station(s)', type: 'exclude', default: [] },
    { name: 'position', label: 'Charts position', type: 'numeric', default: '' },
    { name: 'weeks', label: 'Charts weeks', type: 'numeric', default: '' },
    { name: 'country', label: 'Charts country', type: 'list', default: [] },

  ],
  comparisons: {
    contains: [
      { name: 'like', label: 'contains' },
    ],
    select: [
      { name: 'include', label: 'includes' },
    ],
    alpha: [
      { name: 'like', label: 'contains' },
      { name: 'equals', label: 'is equal to' }
    ],
    numeric: [
      { name: 'equals', label: 'is equal to' },
      { name: 'lower', label: 'is lower than' },
      { name: 'greater', label: 'is greater than' },
      { name: 'between', label: 'between' }
    ],
    list: [
      { name: 'include', label: 'includes' },
      { name: 'exclude', label: 'does not include' }
    ],
    include:[
      { name: 'include', label: 'includes' }
    ],
    exclude:[
      { name: 'exclude', label: 'not in' }
    ],
    equals: [{ name: 'equals', label: 'is equals to' }]
  },
  upload:{
    maxMediasForSimpleUploadApi:4,
    batchOfMedias:3
  },
  acceptedAudioFiles: 'audio/mp3, audio/wav, audio/aac, audio/x-m4a, audio/flac',
  acceptedFiles: 'text/csv',
  labelCategoryID: [
      { value: '', text: 'Choose a category' },
      { value: 1, text: 'Commercial' },
      { value: 2, text: 'Jamendo' },
      { value: 3, text: 'Soundreef' },
      { value: 4, text: 'Ikea' },
      { value: 5, text: 'Tribe of Noise' },
      { value: 6, text: 'Closer Music' },
      { value: 7, text: 'CubeLab' },
      { value: 8, text: 'Rehegoo' },
      { value: 9, text: 'Audiosparx' },
      { value: 10, text: 'Beat Identity' },
    ],
  stationLockedLabel:'Station is locked because it is partially migrated and used by multiple clients.\r\n\r\nPlease use the CMv2 for the moment.',
  stationLockedLabelShort:'Station is locked. Please use the CMv2.'
};

export default Constants;
